<template lang="html">
  <div class="slider">
    <carousel :autoplay="true" :items="1" :nav="false" :loop="true">
      <div class="slide" v-for="slide in slides" :key="slide.title">
        <img class="slide-image" :src="slide.image">
        <div class="slide-cta">
          <h2 class="slide-cta__title">
            {{ slide.title }}
          </h2>
          <h3 class="slide-cta__description">
            {{ slide.description }}
          </h3>
        </div>
      </div>
    </carousel>
  </div>
</template>

<script>

import carousel from 'vue-owl-carousel'

export default {
  name: 'LoginCarousel',
  components: { carousel },
  data () {
    return {
      slides: [
        {
          title: this.$t('login.mfaTitleSetup'),
          description: this.$t('login.mfaDescriptionSetup'),
          image: require('img/login/carousel/step1@3x.png')
        },
        {
          title: this.$t('login.mfaTitleSetup2'),
          description: this.$t('login.mfaDescriptionSetup2'),
          image: require('img/login/carousel/step2@3x.png')
        },
        {
          title: this.$t('login.mfaTitleSetup3'),
          description: this.$t('login.mfaDescriptionSetup3'),
          image: require('img/login/carousel/step3@3x.png')
        }
      ]
    }
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/login/carousel-mfa.vue